interface QuoteProps {
	block: any
}


const Quote = (props: QuoteProps) => {

	const { block } = props

	return (
		<div key={block.id} className="quote">
			<div className="quote__wrapper">
				<div className="quote__content">
					{block.prefix && <span className="quote__prefix">{block.prefix}</span>}
					<p className="quote__main">{block.quote}</p>
					{block.postfix && <span className="quote__postfix">{block.postfix}</span>}
				</div>
			</div>
		</div>
	)

}

export default Quote
